import {apiClient} from 'core/apiClient';
import {DisaggregationReportClientRequest} from 'types';

export async function createDisaggregationDocument(params: DisaggregationReportClientRequest) {
    return (
        await apiClient.post<{reportId: string}>('/marking/disaggregation', params, {
            baseURL: '/api/v2',
        })
    ).data;
}
